import template from 'text!./locationsAndBuildings/locationsAndBuildings.html';
import controller from './locationsAndBuildings/locationsAndBuildingsCtrl';

/**
 * @ngdoc component
 * @name gw-portals-bop-components-angular: gwLocationAndBuildings
 *
 * @description  A component to display locations and buildings page.
 *
 */
export default {
    controller: controller,
    template: template,
    bindings: {
        initialPage: '@'
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-bop-components-angular/locationsAndBuildings/index.js
// module id = 977
// module chunks = 0